var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcStampa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.333,
    height: 17.886,
    viewBox: "0 0 19.333 17.886",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-stampa",
    transform: "translate(-1461.734 -122.585)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_52",
    "data-name": "Rettangolo 52",
    width: 10.668,
    height: 4.503,
    transform: "translate(1466.094 123.085)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_194",
    "data-name": "Raggruppa 194",
    transform: "translate(1462.234 127.588)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_189",
    "data-name": "Tracciato 189",
    d: "M1477.217,155.255h-11.632a3.35,3.35,0,0,0-3.35,3.35v5.6h3.86v-5.039h10.667v5.039h3.806v-5.6A3.35,3.35,0,0,0,1477.217,155.255Z",
    transform: "translate(-1462.234 -155.255)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_53",
    "data-name": "Rettangolo 53",
    width: 10.668,
    height: 8.47,
    transform: "translate(3.86 3.913)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStampa);
export default __webpack_public_path__ + "static/media/ic-stampa.dcfcdf2ceac0ca66db546e937efbd66f.svg";
export { ForwardRef as ReactComponent };